import { MessagePost } from '@web/conversations/types/Message';
import { usePostMessageAction } from '@web/conversations/Conversation/ConversationProvider/hooks/usePostMessageAction';

export const useRetrySend = (message: MessagePost) => {
  const { action: postMessage } = usePostMessageAction();

  return () =>
    postMessage({
      conversationId: message.conversationId,
      message,
      isRetrying: true,
    });
};
